// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"bbb02e6e","211":"eac6bb0a","574":"b084c38b"}[chunkId] + ".chunk.js";
};